import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import accountContext from "../../account/accountContext";
import { Roles } from "../../account/models/AccountModels";

/**
 * Route guard that blocks Viewer role from accessing customer routes.
 * Viewer has no web app access — QR kiosk only.
 * Redirects Viewer to /public/machines (the QR kiosk entry point).
 *
 * Usage in routes:
 * ```tsx
 * <Route element={<ViewerRouteGuard />}>
 *   ... all customer routes ...
 * </Route>
 * ```
 */
const ViewerRouteGuard = () => {
  const user = accountContext.user;

  // If not logged in, let AuthorizedRoute handle the redirect
  if (!user) {
    return <Outlet />;
  }

  // Viewer role: redirect to QR kiosk — no web app access
  if (user.role === Roles.VIEWER) {
    return <Navigate to="/public/machines" replace />;
  }

  return <Outlet />;
};

export default ViewerRouteGuard;
